export const text = {
  ADD_PAYMENT_METHOD: 'Add payment method',
  ADD_METHOD: 'Add method',
  CARD_ADDED_SUCCESS_MSG: 'New payment method added successfully!',
  PRODUCTION: 'PRODUCTION',
  SANDBOX: 'SANDBOX',
  ACCEPT_TEST_URL: 'https://jstest.authorize.net/v1/Accept.js',
  VISIT_RESCHEDULED_SUCCESS: 'This visit is rescheduled!',
}
